import { ArticleParagraph1, UIHeading3, Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { EFileError } from '../../types/alert';

type TChatImageErrorProps = {
  message?: EFileError;
  onClick(): void;
};

export const ChatFileError: React.VFC<TChatImageErrorProps> = ({ message = EFileError.Type, onClick }) => {
  return (
    <div className={styles['container']} data-name="ChatFileError">
      <div className={styles['attention']} />
      <div className={styles['text']}>
        <UIHeading3>Не можем отправить такой файл</UIHeading3>
        <ArticleParagraph1>{message}</ArticleParagraph1>
      </div>
      <Button theme="fill_primary" type="button" onClick={onClick}>
        Выбрать другой файл
      </Button>
    </div>
  );
};
